import { createContext, useContext, useState, useCallback } from 'react';

interface LayoutContextType {
  hideBottomNav: boolean;
  setHideBottomNav: (v: boolean) => void;
}

const LayoutContext = createContext<LayoutContextType>({
  hideBottomNav: false,
  setHideBottomNav: () => {},
});

export function LayoutProvider({ children }: { children: React.ReactNode }) {
  const [hideBottomNav, setHideBottomNavState] = useState(false);
  const setHideBottomNav = useCallback((v: boolean) => setHideBottomNavState(v), []);
  return (
    <LayoutContext.Provider value={{ hideBottomNav, setHideBottomNav }}>
      {children}
    </LayoutContext.Provider>
  );
}

export function useLayout() {
  return useContext(LayoutContext);
}
